import { AuthErrorCode } from '@workspace/auth/errors';
import { Provider } from '@workspace/auth/providers.types';
import {
  FeedbackCategory,
  Role,
  WebhookTrigger
} from '@workspace/database/schema';

export const roleLabels: Record<Role, string> = {
  [Role.MEMBER]: 'Mitglied',
  [Role.ADMIN]: 'Administrator'
};

export const feedbackCategoryLabels: Record<FeedbackCategory, string> = {
  [FeedbackCategory.SUGGESTION]: 'Vorschlag',
  [FeedbackCategory.PROBLEM]: 'Problem',
  [FeedbackCategory.QUESTION]: 'Frage'
};

// TODO: These contact triggers will be removed when database schema is updated
export const webhookTriggerLabels: Record<WebhookTrigger, string> = {
  [WebhookTrigger.PLACEHOLDER]: 'Placeholder (Add accounting triggers when ready)'
};

export const identityProviderLabels: Record<Provider, string> = {
  [Provider.Credentials]: 'Anmeldedaten',
  [Provider.TotpCode]: 'TOTP-Code',
  [Provider.RecoveryCode]: 'Wiederherstellungscode',
  [Provider.Google]: 'Google',
  [Provider.MicrosoftEntraId]: 'Microsoft'
};

export const authErrorLabels: Record<AuthErrorCode, string> = {
  [AuthErrorCode.NewEmailConflict]: 'E-Mail-Adresse existiert bereits.',
  [AuthErrorCode.UnverifiedEmail]: 'E-Mail-Adresse ist nicht verifiziert.',
  [AuthErrorCode.IncorrectEmailOrPassword]: 'E-Mail-Adresse oder Passwort ist nicht korrekt.',
  [AuthErrorCode.TotpCodeRequired]: 'TOTP-Code ist erforderlich.',
  [AuthErrorCode.IncorrectTotpCode]: 'Der TOTP-Code ist nicht korrekt.',
  [AuthErrorCode.MissingRecoveryCodes]: 'Wiederherstellungscodes fehlen.',
  [AuthErrorCode.IncorrectRecoveryCode]: 'Der Wiederherstellungscode ist nicht korrekt.',
  [AuthErrorCode.RequestExpired]: 'Anfrage ist abgelaufen.',
  [AuthErrorCode.RateLimitExceeded]: 'Ratenlimit überschritten.',
  [AuthErrorCode.IllegalOAuthProvider]: 'Unzulässiger OAuth-Anbieter.',
  [AuthErrorCode.InternalServerError]:
    'Etwas ist schiefgelaufen. Bitte versuchen Sie es später erneut.',
  [AuthErrorCode.MissingOAuthEmail]: 'OAuth-E-Mail fehlt.',
  [AuthErrorCode.AlreadyLinked]: 'OAuth-Konto wurde bereits verknüpft.',
  [AuthErrorCode.RequiresExplicitLinking]:
    'Bitte melden Sie sich zuerst an, um dieses Konto zu verknüpfen',
  [AuthErrorCode.UnknownError]: 'Unbekannter Fehler.'
};
